import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { firestore } from '../../../firebase'

function AuthorFollowersList({followers, setShow}) {




    return (
        <div>
            <ul className="list-group">
                {followers && followers.map((author, index) => {
                    return (
                        <li style={{listStyle: "none", textAlign: "left"}} key={index}>
                            <div className="mr-auto">
                                <Link to={`/member/${author.follower_id}`}  onClick={() => setShow(false)}>
                                    <img 
                                        src={author.follower_profile_image} 
                                        alt={author.name} 
                                        className="img-fluid rounded-circle" 
                                        style={{maxWidth: "2rem"}}
                                    /> 
                                </Link>
                                <span>  
                                    <Link to={`/member/${author.follower_id}`} onClick={() => setShow(false)}> {author.followed_name}  følges av {author.follower_name}</Link>
                                </span> 
                                <span className="float-right">
                                    <div className="bg-light p-1">følger</div>
                                </span>
                            </div>
                            <hr />
                        </li>
                    )
                })}
            </ul>
        </div>
    )

}
export default AuthorFollowersList